<table class="lum-table lum-table--classic striped">
  <tr>
    <th>Product Name</th>
    <th class="w-99">Supplier Name</th>
    <th>SKU</th>
  </tr>
  <tbody>
    <ng-container
      *ngFor="
        let supplierSkuControl of supplierSkusControl.controls;
        trackBy: trackById
      "
    >
      <tr>
        <td class="w-64">{{ supplierSkuControl.value?.product?.productName }}</td>
        <td class="w-99">
          <lum-ui-autocomplete
            placeholder="'Search supplier'"
            [options]="suppliers"
            [debounceTime]="500"
            [loading]="loadingSupplier"
            [displayProperty]="'factoryName'"
            [control]="supplierSkuControl.get('supplier')"
            (inputChangeEvent)="onSearchSupplierChange($event)"
            (optionSelectedEvent)="onSelectSupplier($event, supplierSkuControl)"
          ></lum-ui-autocomplete>
        </td>
        <td class="w-99">
          <input
            type="text"
            class="lum-input"
            [formControl]="supplierSkuControl.get('sku')"
            lumDebounceTime
            (debounceValue)="onUpdateSupplierSku($event, supplierSkuControl)"
          />
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
